/**
 * Lists `TeamStreamPreviewCard` rows for experiment/team membership with an empty state.
 *
 * Where: `LeadOverview` teams/streams accordion.
 * Uses: `TeamStreamPreviewCard` for each membership row.
 * Behavior: empty state when no `teamProspects`.
 */
import React from 'react';
import {
  Typography,
  Stack,
} from '@mui/material';
import { TeamStreamPreviewCard } from './TeamStreamPreviewCard';

interface TeamsStreamsListProps {
  teamProspects: any[];
  onOpenTeam?: (teamUuid: string) => void;
  onOpenStream?: (streamUuid: string) => void;
}

export const TeamsStreamsList: React.FC<TeamsStreamsListProps> = ({
  teamProspects,
  onOpenTeam,
  onOpenStream,
}) => {
  return (
    <Stack spacing={1}>
      {teamProspects.map((pp: any) => (
        <TeamStreamPreviewCard key={pp.key || pp.uuid} teamProspect={pp} onOpenTeam={onOpenTeam} onOpenStream={onOpenStream} />
      ))}
      {teamProspects.length === 0 && (
        <Typography variant="body2" color="text.secondary">No experiment membership</Typography>
      )}
    </Stack>
  );
};
